import { apiUrls } from 'consts'
import { useEffect } from 'react'
import loadRecord from './../utils/loadRecord'

interface useInitProps {
  getValues: Function
  id: string | undefined
  reset: Function
  setDataLoaded: Function
  setShowOverlay: Function
  currentCustomer: {} | null
  setInitUrl: Function
  setStaticContent: Function
}

const useInit = (props: useInitProps) => {
  useEffect(() => {
    // fetch the device if edit
    if (props.id !== undefined) {
      loadRecord(apiUrls.pages, props.id).then((data) => {
        const staticContent = data.static_content === null ? '' : data.static_content
        props.setStaticContent(staticContent)
        props.reset(data)
        props.setInitUrl(data.url)

        props.setDataLoaded(true)
        props.setShowOverlay(false)
      })
    } else {
      props.setDataLoaded(true)
      props.setShowOverlay(false)
    }
  }, [props.currentCustomer])
}

export default useInit
